import React from 'react';
import { getMobileMenu } from 'utils';

export default function withMobileMenu(Component) {
    return props => <Component mobileMenu={getMobileMenu()} {...props} />;
}
